<template>
  <div class="section">
    <b-field class="mb-10">
      <template slot="label">
        <div class="level">
          <div class="level-left">
            <p class="subtitle is-6"> {{label}} </p>
          </div>
          <div class="level-rigth">
            <a @click="deleteFilter" class="secondary-icon">
              <b-icon icon="delete-forever" size="is-normal"
                class="is-pulled-right" />
            </a>
          </div>
        </div>
      </template>
      <b-taginput
        v-model="listeTags"
        :data="filtreTags"
        autocomplete
        field="name"
        icon="magnify"
        placeholder="Rechercher"
        @typing="getFilteredTags"
        @add="setValue"
        @remove="setValue"
        :disabled="!address"
        type="is-info">
      </b-taginput>
    </b-field>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';

const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  name: 'filtreAutoComplete',
  props: {
    propriete: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      listeTags: [],
      filtreTags: [],
    };
  },
  watch: {
    panneauxLc() {
      this.init();
    },
  },
  computed: {
    ...VenteFacesLc.mapGetters({
      address: 'address',
      filtresDynamiques: 'filtresDynamiques',
      panneauxLc: 'panneauxLc',
    }),
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setSelectFiltreDynamique: types.SELECT_FILTRE_DYNAMIQUE,
      setRemoveFilterProperty: types.REMOVE_FILTER_PROPERTY,
      setAddFilterProperty: types.ADD_FILTER_PROPERTY,
    }),
    ...VenteFacesLc.mapActions({
      actionsAjoutFiltresDynamiques: 'ajoutFiltresDynamiques',
      actionsGestionFiltres: 'gestionFiltres',
    }),
    init() {
      this.listeTags = [];
      this.setSelectFiltreDynamique(this.propriete);
      this.actionsAjoutFiltresDynamiques(
        {
          property: this.propriete,
          valueProperty:
            {
              id: this.propriete,
              variable: this.propriete,
              valeur: [],
              app: 'app-filtre-auto-complete',
            },
        },
      );
      this.filtreTags = this.filtresDynamiques.find((el) => {
        return el.id === this.propriete;
      }).valeur.map(el => el.name);
    },
    getFilteredTags(text) {
      const data = this.filtresDynamiques.find((el) => {
        return el.id === this.propriete;
      }).valeur.map(el => el.name);
      this.filtreTags = data.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    setValue() {
      this.setAddFilterProperty(
        {
          property: this.propriete,
          valueProperty:
            {
              variable: this.propriete,
              valeur: this.listeTags,
              app: 'app-filtre-auto-complete',
            },
        });
      this.actionsGestionFiltres();
    },
    deleteFilter() {
      this.setRemoveFilterProperty(this.propriete);
      this.actionsGestionFiltres();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/filtreAutocomplete.vue